module.exports = __webpack_public_path__ + "img/atom.01295875.svg";